// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__V4FiA","badgeDefault":"Badge_badgeDefault__88ABr","badgeSecondary":"Badge_badgeSecondary__2Ikt7"};